
import { Injectable } from '@angular/core';
import { BackendService } from '../../backend.service';
import { WhiteListResponse } from '../white-list';
import { Observable } from 'rxjs';
import { MerchantSettings } from './gift-card';
import { environment } from 'environments/environment';

@Injectable()
export class GiftCardService {

  private getFaqsUrl = '/giftCardFaqs.json';
  private getNewFaqsUrl = '/gift-card/faqs.json';
  private getTnCsUrl = '/gift-card/tncs.json';
  private getCromaFaqsUrl = '/CromaFaqs.json';
  private getFaqsEmployeesUrl = '/giftCardEmployees.json';
  private getWalletFaqsUrl = '/walletFaqs.json';
  private checkForTechnicalIssuesUrl = '/giftCardTechnicalIssues.json';
  private fundWalletUrl = '/wallet/api/v1/loanApplication';
  private fundWalletv2Url = '/wallet/api/v2/loanApplication';
  private whitelistUrl = '/whitelisting/api/v1/merchants/{{merchantId}}';
  private getMobileNumberUrl = '/Comms/customers/{customerId}/MobilePhone';
  private getGiftCardMerchants = '/merchantsetting/merchants/giftcard?isLanding=true';
  private getGiftCardMerchantSettings = '/zestlife/v1/Customers/{customerId}/GiftCard/MerchantSettings';
  private getCorporateNameUrl = '/HSBC-Landing-Page/corporate-names.json';
  private createGCTransactionUrl = '/zestlife-channel/api/v1/redemption/customers/{customerId}/transaction';
  private whitelistUrlZestLife = '/zestlife/v1/Customers/{customerId}/Merchants/{merchantId}';

  constructor(private backendService: BackendService) { }

  getFaqs() {
    return this.backendService.getData(this.getFaqsUrl, null, false, true, true);
  }
  getNewFaqs() {
    return this.backendService.getData(this.getNewFaqsUrl, null, false, true, true);
  }
  getTnCs() {
    return this.backendService.getData(this.getTnCsUrl, null, false, true, true);
  }
  getCromaFaqs() {
    return this.backendService.getData(this.getCromaFaqsUrl, null, false, true, true);
  }
  getFaqsEmployees() {
    return this.backendService.getData(this.getFaqsEmployeesUrl, null, false, true, true);
  }
  fundWallet(data) {
    return this.backendService.setData(this.fundWalletUrl, data);
  }
  fundWalletv2(data) {
    return this.backendService.setData(this.fundWalletv2Url, data);
  }
  getWalletFaqs() {
    return this.backendService.getData(this.getWalletFaqsUrl, null, false, true, true);
  }
  checkForTechnicalIssues() {
    return this.backendService.getData(this.checkForTechnicalIssuesUrl, null, false, true, true);
  }
  getWhiteListedCustomer(merchantId, phoneNumber, customerId: string = ''): Observable<WhiteListResponse> {
    let url;
    if (customerId) {
      url = this.whitelistUrl + '/customers/' + customerId;
    } else {
      url = this.whitelistUrl + '/phone-numbers/' + phoneNumber;
    }
    return this.backendService.getCallForWhiteList(url.replace('{{merchantId}}', merchantId));
  }

  getWhiteListedCustomerZestLife(merchantId, phoneNumber, customerId: string = ''): Observable<WhiteListResponse> {
    const url = this.whitelistUrlZestLife;
    return this.backendService.getData(url.replace('{merchantId}', merchantId));
  }

  getMobileNumber() {
    return this.backendService.getData(this.getMobileNumberUrl, null, false);
  }

  getGCMerchantsList(): Observable<MerchantSettings> {
    return this.backendService.getCallForMerchantList(this.getGiftCardMerchants);
  }

  getGCMerchantSettings(): Observable<MerchantSettings> {
    return this.backendService.getData(this.getGiftCardMerchantSettings);
  }

  getCorporateNames(): Observable<any> {
    return this.backendService.getData(this.getCorporateNameUrl, '', false, false, true);
  }
  createGCTransaction(payload: any): Observable<any> {
    return this.backendService.setData(this.createGCTransactionUrl, payload, '', false, false, false, false, { 'payment-gateway-id': environment.hsbcPaymentGatewayId });
  }
}
